import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import {
  POSITION_BOTTOM,
  POSITION_LEFT,
  POSITION_RIGHT,
  POSITION_TOP
} from '../../utilities/constants';

const ToolTip = ({ children, text, position, positionDistance, width, textFontFamily }) => (
  <Container>
    {children}
    {text && (
      <Text
        position={position}
        positionDistance={positionDistance}
        containerWidth={width}
        textFontFamily={textFontFamily}
      >
        {text}
      </Text>
    )}
  </Container>
);

ToolTip.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  position: PropTypes.oneOf([POSITION_TOP, POSITION_LEFT, POSITION_BOTTOM, POSITION_RIGHT]),
  positionDistance: PropTypes.number,
  width: PropTypes.string,
  textFontFamily: PropTypes.string
};

ToolTip.defaultProps = {
  position: POSITION_TOP,
  positionDistance: -8,
  width: 'auto'
};

const Text = styled.span`
  position: absolute;
  z-index: 2;
  display: none;
  width: ${props => props.containerWidth};
  max-width: ${props => (props.containerWidth ? '100%' : '194px')};
  padding: 4px 8px;
  font-family: ${props => props.textFontFamily};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #fff;
  background-color: #555;
  border-radius: 3px;

  ${({ position }) => {
    switch (position) {
      case POSITION_TOP:
        return css`
          &&& {
            top: ${props => props.positionDistance}px;
            left: 50%;
            transform: translate(-50%, -100%);
            ::after {
              content: '';
              position: absolute;
              top: 100%;
              left: 50%;
              margin-top: -7px;
              border-width: 6px;
              border-style: solid;
              border-color: #555 transparent transparent transparent;
              transform: translate(-50%, 50%);
            }
          }
        `;

      case POSITION_RIGHT:
        return css`
          &&& {
            top: 50%;
            right: ${props => props.positionDistance}px;
            transform: translate(100%, -50%);
            ::after {
              content: '';
              position: absolute;
              top: 50%;
              right: calc(100% - 1px);
              margin-top: -6px;
              border-width: 6px;
              border-style: solid;
              border-color: transparent #555 transparent transparent;
            }
          }
        `;
      case POSITION_BOTTOM:
        return css`
          &&& {
            bottom: -${props => props.positionDistance}px;
            left: 50%;
            transform: translate(-50%, 100%);
            ::after {
              content: '';
              position: absolute;
              top: 0;
              left: 50%;
              margin-top: -5px;
              border-width: 6px;
              border-style: solid;
              border-color: transparent transparent #555 transparent;
              transform: translate(-50%, -50%);
            }
          }
        `;
      case POSITION_LEFT:
        return css`
          &&& {
            top: 50%;
            left: -${props => props.positionDistance}px;
            transform: translate(-100%, -50%);
            ::after {
              content: '';
              position: absolute;
              top: 50%;
              left: calc(100% - 1px);
              margin-top: -6px;
              border-width: 6px;
              border-style: solid;
              border-color: transparent transparent transparent #555;
            }
          }
        `;

      default:
        return null;
    }
  }}
`;

const Container = styled.div`
  position: relative;
  display: inline-block;
  /* the rule needs only for IE */
  width: 100%;

  :hover ${Text} {
    display: inline-block;
  }
`;

export default ToolTip;
